const culturalCoordinatorData = [
  {
    name: "Ayush Mishra",
    contact: "+91 9354007718",
    // course: "B.Tech IT",
    image: "Ayush",
  },
  {
    name: "Harshita Phulwani",
    contact: "+91 6387891733",
    // course: "B.Tech CSE",
    image: "Harshita",
  },
  {
    name: "Rajesh Sharma",
    contact: "+91 7048990866",
    // course: "B.Tech CSE",
    image: "Rajesh",
  },
];
export default culturalCoordinatorData;
